import React from "react";
import styled from "styled-components";


export default styled.button`
    float: right;
    width: 31px;
    height: 31px;
    border-radius: 500px;
    border: none;
    background: rgb(78 153 214);
    color: white;
    font-size: 33px;
    line-height: 25px;
    font-weight: 700;
    display: ${(props) => (props.hidden ? "none" : "inline-block")};

    @media(max-width: 787px) {
        position: absolute;
        left: 0;
        float: left;
        top: 50%;
        transform: translateY(-50%);
        width: 25px;
        height: 25px;
        font-size: 22px;
        line-height: 19px;
    }
`;
